import { noop } from 'lodash';

export const updateMParticleATTStatus = noop;
